@if (products$ | async; as products) {
<div class="products" [class.horizontal]="!rowsEnabled">
  @for (product of products; track product) {
  <epc-product-card
    class="p-card"
    [product]="product"
    [prices]="product.priceRanges"
    (cardClick)="clickedProductCard(product)"
  >
  </epc-product-card>
  }
</div>
}
